export enum OtherServiceEnum {}

export enum AdsServiceEnum {
  HOME_HEADER = "home_header",
  HOME_SIDEBAR = "home_sidebar",
  HOME_POPUP = "home_popup",
  HOME_INTERSTITIAL = "home_interstitial",
  HOME_IN_FEED = "home_in-feed",
  HOME_FOOTER = "home_footer",

  PROPERTIES_HEADER = "properties_header",
  PROPERTIES_SIDEBAR = "properties_sidebar",
  PROPERTIES_POPUP = "properties_popup",
  PROPERTIES_INTERSTITIAL = "properties_interstitial",
  PROPERTIES_IN_FEED = "properties_in-feed",
  PROPERTIES_FOOTER = "properties_footer",

  WEEKLY_DEALS_HEADER = "weekly-deals_header",
  WEEKLY_DEALS_SIDEBAR = "weekly-deals_sidebar",
  WEEKLY_DEALS_POPUP = "weekly-deals_popup",
  WEEKLY_DEALS_INTERSTITIAL = "weekly-deals_interstitial",
  WEEKLY_DEALS_IN_FEED = "weekly-deals_in-feed",
  WEEKLY_DEALS_FOOTER = "weekly-deals_footer",

  DEVELOPERS_HEADER = "developers_header",
  DEVELOPERS_SIDEBAR = "developers_sidebar",
  DEVELOPERS_POPUP = "developers_popup",
  DEVELOPERS_INTERSTITIAL = "developers_interstitial",
  DEVELOPERS_IN_FEED = "developers_in-feed",
  DEVELOPERS_FOOTER = "developers_footer",

  REALTORS_HEADER = "realtors_header",
  REALTORS_SIDEBAR = "realtors_sidebar",
  REALTORS_POPUP = "realtors_popup",
  REALTORS_INTERSTITIAL = "realtors_interstitial",
  REALTORS_IN_FEED = "realtors_in-feed",
  REALTORS_FOOTER = "realtors_footer",

  BLOG_HEADER = "blog_header",
  BLOG_SIDEBAR = "blog_sidebar",
  BLOG_POPUP = "blog_popup",
  BLOG_INTERSTITIAL = "blog_interstitial",
  BLOG_IN_FEED = "blog_in-feed",
  BLOG_FOOTER = "blog_footer",

  MANAGED_PROPERTIES_HEADER = "managed-properties_header",
  MANAGED_PROPERTIES_SIDEBAR = "managed-properties_sidebar",
  MANAGED_PROPERTIES_POPUP = "managed-properties_popup",
  MANAGED_PROPERTIES_INTERSTITIAL = "managed-properties_interstitial",
  MANAGED_PROPERTIES_IN_FEED = "managed-properties_in-feed",
  MANAGED_PROPERTIES_FOOTER = "managed-properties_footer",

  MANAGED_DEVELOPMENTS_HEADER = "managed-developments_header",
  MANAGED_DEVELOPMENTS_SIDEBAR = "managed-developments_sidebar",
  MANAGED_DEVELOPMENTS_POPUP = "managed-developments_popup",
  MANAGED_DEVELOPMENTS_INTERSTITIAL = "managed-developments_interstitial",
  MANAGED_DEVELOPMENTS_IN_FEED = "managed-developments_in-feed",
  MANAGED_DEVELOPMENTS_FOOTER = "managed-developments_footer",

  CONTACT_US_HEADER = "contact-us_header",
  CONTACT_US_SIDEBAR = "contact-us_sidebar",
  CONTACT_US_POPUP = "contact-us_popup",
  CONTACT_US_INTERSTITIAL = "contact-us_interstitial",
  CONTACT_US_IN_FEED = "contact-us_in-feed",
  CONTACT_US_FOOTER = "contact-us_footer",
}

export const CompanyServiceEnum = [
  ...Object.values(OtherServiceEnum),
  ...Object.values(AdsServiceEnum),
] as const;

export type CompanyServiceId = (typeof CompanyServiceEnum)[number];

export enum ServiceTag {
  ADS = "ads",
  LIVE_INSPECTION = "live_inspection",
  INSPECTION_REPORT = "inspection_report",
  SUBSCRIPTION = "subscription_plan",
  OTHERS = "others",
}

/* ─── Data model ─────────────────────────────────────────────── */

export interface CompanyService {
  id: string;
  service_id: string;
  service_label: string;
  amount: number;
  description?: string;
  is_active: boolean;
  tag: string | null;
  discount: number;
  discount_units_threshold: number;
  price_history: Array<{
    old_amount: number;
    new_amount: number;
    changed_at: string;
  }>;
}

export interface AdPriceComponent {
  id: string;
  name: string;
  type: "page" | "placement";
  amount: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

/* ─── Request payloads ───────────────────────────────────────── */

export interface CreateCompanyServicePayload {
  service_id: string;
  service_label: string;
  amount: number;
  description?: string;
  is_active?: boolean;
  tag?: ServiceTag | null;
  discount?: number;
  discount_units_threshold?: number;
}

export interface UpdateCompanyServicePayload {
  service_label?: string;
  amount?: number;
  description?: string;
  is_active?: boolean;
  tag?: ServiceTag | null;
  discount?: number;
  discount_units_threshold?: number;
}

export interface UpdateAdPriceComponentPayload {
  amount?: number;
  is_active?: boolean;
}

export interface UpdateAdPriceComponentsPayload {
  updates: Array<{
    id: string;
    amount?: number;
    is_active?: boolean;
  }>;
}

/* ─── Response wrappers ──────────────────────────────────────── */

// Single service
export interface CompanyServiceApiResponse {
  success: boolean;
  data: CompanyService;
}

export interface CompanyServiceListApiResponse {
  success: boolean;
  data: CompanyService[];
}

export interface CreateCompanyServiceApiResponse {
  success: boolean;
  data: CompanyService;
}

export interface UpdateCompanyServiceApiResponse {
  success: boolean;
  data: CompanyService;
}

export interface DeleteCompanyServiceApiResponse {
  success: boolean;
  message: string;
}

// Initialize ads prices
export interface InitializeAdsPricesApiResponse {
  success: boolean;
  data: {
    message: string;
    created_count: number;
    data: CompanyService[];
  };
}

// Ad price components
export interface AdPriceComponentListApiResponse {
  success: true;
  data: AdPriceComponent[];
}

export interface AdPriceComponentSingleApiResponse {
  success: true;
  data: {
    component: AdPriceComponent;
    affected_services: CompanyService[];
  };
}

export interface AdPriceComponentBatchApiResponse {
  success: true;
  data: {
    components: AdPriceComponent[];
    affected_services: CompanyService[];
    errors?: Array<{ id: string; error: string }>;
  };
}
